import { render, staticRenderFns } from "./NotificationHistory.vue?vue&type=template&id=488ee19c&scoped=true"
import script from "./NotificationHistory.vue?vue&type=script&lang=js"
export * from "./NotificationHistory.vue?vue&type=script&lang=js"
import style0 from "./NotificationHistory.vue?vue&type=style&index=0&id=488ee19c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488ee19c",
  null
  
)

export default component.exports